export enum UserOperationType {
  UPDATE_GROUP = 'updateGroup',
  DELETE_USER = 'deleteUser',
  UPDATE_TENANT = 'updateTenant',
}
